import React, { useState } from "react";
import "./Common_Product_Card.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeart as solidHeart,
  faStar,
  faHeart,
} from "@fortawesome/free-solid-svg-icons";
import { faHeart as regularHeart } from "@fortawesome/free-regular-svg-icons";
import Black_Btn from "../common_btn/Black_Btn/Black_Btn";
import { useNavigate } from "react-router-dom";
import { encodeId } from "../../../utils/common";
import parse from "html-react-parser";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllWishlist,
  postWishlist,
} from "../../../features/wishlist/wishlistSlice";
import Login_Modal from "../common_modal/login_flow/login_modal/Login_Modal";
const Common_Product_Card = ({
  imgSrc,
  discount,
  productName,
  rating,
  review,
  feature,
  emi,
  sellingPrice,
  mrp,
  id,
  product,
  btnText,
}) => {
  const [favouriteProduct, setFavouriteProduct] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [isLogedIn, setIsLogedIn] = useState(false);
  const [showAccountCreted, setShowAccountCreted] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isSignIn = useSelector((state) => state.auth.is_signin);
  const postWishlistData = async (id) => {
    const res = await dispatch(postWishlist(id));

    if (res.meta?.requestStatus === "fulfilled") {
      await dispatch(getAllWishlist());
      // await dispatch(getAllProducts({}));
      // await dispatch(getGroupByProduct({}));
    } else if (res.meta?.requestStatus === "rejected") {
    }
  };

  const allWishlist = useSelector((state) => state.wishlist.allWishlist);
  return (
    <div className="Common_Product_Card">
      <div
        className="img_holder"
        onClick={() => {
          navigate(`/product-description/${encodeId(id)}`);
        }}
      >
        <img src={imgSrc} className="prod_img" />

        {discount && (
          <div className="discount_div">
            <p className="inner_text">
              {discount} %<br />
              off
            </p>
          </div>
        )}
      </div>

      <div className="product_info_div">
        <p
          className="name"
          onClick={() => {
            navigate(`/product-description/${encodeId(id)}`);
          }}
        >
          {productName}
        </p>
        <div className="price_div">
          <p className="selling_price">₹ {sellingPrice}</p>
          <p className="mrp">₹ {mrp}</p>
        </div>
        <div className="bottom_div">
          <p className="left_text">
            {/* or EMI <span className="green_text">₹{emi}/mo</span>{" "} */}
          </p>

          <p className="review_text">
            <FontAwesomeIcon icon={faStar} className="star" />{" "}
            {Number(product?.avg_rating).toFixed(1)}{" "}
            <span className="gray_text">({product?.review_count} Reviews)</span>
          </p>
        </div>

        <div className="list_div">
          <ul>
            {/* {typeof feature === "string" ? parse(feature) : null} */}
            {feature?.map((item) => {
              return <li className="list_txt">{item?.name}</li>;
            })}
          </ul>
        </div>
        {isSignIn && (
          <div className="favourite_div" onClick={() => postWishlistData(id)}>
             <FontAwesomeIcon
              icon={
                allWishlist?.data?.some((item) => item.product_id === id)
                  ? solidHeart
                  : regularHeart
              }
              className="heart_icon"
            />
          </div>
        )}

        {!isSignIn && (
          <div
            className="favourite_div"
            onClick={() => setShowLoginModal(true)}
          >
            <FontAwesomeIcon
              icon={
                allWishlist?.data?.some((item) => item.product_id === id)
                  ? solidHeart
                  : regularHeart
              }
              className="heart_icon"
            />
          </div>
        )}
      </div>

      <div className="btn_holder">
        <Black_Btn
          btnText={btnText}
          onClick={() => {
            navigate(`/product-description/${encodeId(id)}`);
          }}
        />
      </div>

      <Login_Modal
        show={showLoginModal}
        onHide={() => {
          setShowLoginModal(false);
        }}
        loginDone={() => {
          setIsLogedIn(true);
        }}
        setShowResetModal={() => setShowResetModal(true)}
        setShowAccountCreted={() => setShowAccountCreted(true)}
      />
    </div>
  );
};

export default Common_Product_Card;
